'use strict';

// noinspection JSValidateTypes
/**
 * @ngdoc service
 * @name gfcmsApp.schedule.service
 * @description
 * # schedule.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('scheduleService', function($http, $cookies, $rootScope, $q, BaseService, errorService, FileSaver, Blob,
                                       jobFactory) {

    var service = new BaseService();
    service.GetAll = GetAll;
    service.GetById = GetById;
    service.Create = Create;
    service.Delete = Delete;
    service.getMaintenanceCustomers = getMaintenanceCustomers;
    service.saveJobs = saveJobs;
    service.getJobs = getJobs;
    service.getUserSchedules = getUserSchedules;
    service.download = downloadSchedule;

    function GetAll() {
      var deferred = $q.defer();

      return service.http.get(service.baseUrl + '/schedules')
      .then(handleSuccess)
      .catch(handleError);
    }

    function GetById(id) {
      return service.http.get(service.baseUrl + '/schedules/' + id)
      .then(handleSuccess)
      .catch(handleError);
    }

    function Create(schedule) {
      return service.http.post(service.baseUrl + '/schedules', schedule)
      .then(handleSuccess)
      .catch(handleError);
    }

    function Delete(id) {
      return service.http.delete(service.baseUrl + '/schedules/' + id)
      .then(handleSuccess)
      .catch(handleError);
    }

    function getMaintenanceCustomers(scheduleId) {
      var url = !!scheduleId ?
        service.baseUrl + '/customers/maintenance?scheduleId=' + scheduleId
        : service.baseUrl + '/customers/maintenance';
      return service.http.get(url)
      .then(handleSuccess)
      .catch(handleError);
    }

    /**
     * @typedef Schedule
     * @property { string } id
     * @property { Job[] } jobs
     * @property { string } dateCreated
     * @property { string } monthYearFor
     * @property { string } recipient
     * @property { string } createdByUserId
     * @property { string } type
     */

    /**
     *
     * @param id
     * @returns { Promise.<Job[]> }
     */
    function getJobs(id) {
      return service.http.get(service.baseUrl + '/schedules/' + id + '/jobs')
      .then(mapJobs)
      .catch(handleError);
    }

    function getUserSchedules() {
      return service.http.get(service.baseUrl + '/my/schedules')
      .then(handleSuccess)
      .catch(handleError);
    }

    function saveJobs(id, jobs) {
      return service.http.post(service.baseUrl + '/schedules/' + id + '/jobs', jobs)
      .then(handleSuccess)
      .catch(handleError);
    }

    function downloadSchedule(id, filename) {
      return downloadFile(service.baseUrl +  '/schedules/' + id + '/download')
      .then(function(response) {
        filename = !!filename ? filename : 'schedule';
        openSaveAsDialog(filename, response, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
      });
    }

    function downloadFile(url) {
      return service.http({
          method: 'GET',
          url: url,
          responseType: 'arraybuffer'
        })
        .then(handleSuccess)
        .catch(handleError);
    }


    /**
     * @param { { data: JobDto[] } } response
     * @returns { Job[] }
     */
    function mapJobs(response) {
      return handleSuccess(response)
        .map(function (value) {
          return jobFactory.create(value);
        });
    }

    function handleSuccess(response) {
      return response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }

    function openSaveAsDialog(filename, content, mediaType) {
      var blob = new Blob([content], {
        type: mediaType
      });
      FileSaver.saveAs(blob, filename);
    }

    return service;
  });
